(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  $('.form-search').on('submit', function(e) {
    let searchVal = $(this).find('.banner-input').val();
    let inputHidden = $('.banner-input-hidden');

    if (searchVal) {
      inputHidden.val(searchVal.replace('\u3000', ' '));
    } else {
      inputHidden.val('#');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-activate-account"]) return;
  try {
    
    $(document).ready(function () {
    var regexCharacter = /[a-zA-Z]/;
    var regexNumber = /[0-9]/;
    var regexSpecialCharacter = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    var btnActiveAccount = $(".button-active-account");
    var btnActiveAccountCancel = $(".button-unactive-account");
    var elTextErrorPassword = $(".text-error-password");
    var elTextConfirmPwError = $(".text-error-confirmpw");
    const errorRequired = '必須項目です。入力してください。';
    const errorEqualTo = '同じパスワードを入力してください。';
    const errorValidator = '複数の文字種 (英数記号) を組み合わせた8文字以上で入力してください。';

    btnActiveAccount.on("click", function () {
      localStorage.setItem("reset-password-register", true);
    });

    let inputPassword = $("#password");
    let inputConfirmationPassword = $("#password_confirmation");
    let showPassword = $("#show-password");
    let showConfirmPassword = $("#show-password-confirm");

    function setOriginalState() {
      inputPassword.attr("type", "password");
      showPassword.text("Show");
    }

    function setOriginalStateConfirm() {
      inputConfirmationPassword.attr("type", "password");
      showConfirmPassword.text("Show");
    }

    showPassword.on("click", () => {
      const isPassword = inputPassword.attr("type") === "password";
      const isConfirmationPassword = inputConfirmationPassword.attr("type") === "password";
      if (isPassword) {
        inputPassword.attr("type", "text");
        $(this).text("Hide");
      } else {
        setOriginalState();
      }
    });

    showConfirmPassword.on("click", () => {
      const isConfirmationPassword = inputConfirmationPassword.attr("type") === "password";

      if (isConfirmationPassword) {
        inputConfirmationPassword.attr("type", "text");
        $(this).text("Hide");
        setOriginalStateConfirm;
      } else {
        setOriginalStateConfirm();
      }
    });

    function checkValidate(elName, errorNumber, elTextError) {
      let elPassword = $("#" + elName);
      let val = $("#" + elName).val();
      let checkPassword = errorNumber;

      if (regexCharacter.test(val)) {
        checkPassword += 1;
      }

      if (regexNumber.test(val)) {
        checkPassword += 1;
      }

      if (regexSpecialCharacter.test(val)) {
        checkPassword += 1;
      }

      if (checkPassword >= 2 && val.length >= 8) {
        if (inputPassword.val() == inputConfirmationPassword.val()) {
          elPassword.removeClass("input-error");
          inputConfirmationPassword.removeClass("input-error");
          elTextConfirmPwError.hide();
          elTextError.hide();
          btnActiveAccount.css("background-color", "#02A900").prop("disabled", false);
          btnActiveAccountCancel.prop("disabled", false);
          return true;
        } else if (elName == "password") {
          elPassword.removeClass("input-error");

          if (inputConfirmationPassword.val() != '') {
            inputConfirmationPassword.addClass("input-error");
            elTextConfirmPwError.text(errorEqualTo).show();
            elTextConfirmPwError.css("color", "rgb(200, 27, 27)");
          }

          elTextError.hide();
          btnActiveAccount.css("background-color", "#b7b7b7").prop("disabled", true);
          btnActiveAccountCancel.prop("disabled", true);
          return false;
        }
      }

      elPassword.addClass("input-error");
      elTextError.css("color", "#C81B1B").show();
      btnActiveAccount.css("background-color", "#b7b7b7").prop("disabled", true);
      btnActiveAccountCancel.prop("disabled", true);

      if (val == "") {
        elTextError.text(errorRequired);
        return false;
      }

      if (val != inputPassword.val() && elName == "password_confirmation") {
        elTextError.text(errorEqualTo);
        return false;
      }

      elTextError.text(errorValidator);
    }

    inputPassword.on("input", function () {
      checkValidate("password", 0, elTextErrorPassword);
    });

    inputConfirmationPassword.on("input", function () {
      checkValidate("password_confirmation", 0, elTextConfirmPwError);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  $(document).ready(function () {
    var editAddressForm = $('#edit_address_form');
    var selectStartTime = $('[name="acceptable_time_start"]');
    var selectStarEnd = $('[name="acceptable_time_end"]');

    if ((new URLSearchParams(window.location.search)).get('address_id') != null) {
      var zipCodeInput = $('#zip_code');

      var interValObj = setInterval(function () {
        if (zipCodeInput.val().trim() != '') {
          zipCodeInput.val(zipCodeInput.val().replace('-', ''));
          clearInterval(interValObj);
        }
      }, 100);
    }

    $('#submit-button').on('click', function () {
      let validAddressForm = $(this).parents("form").valid();

      checkErrorMessage();

      if (!validAddressForm) {
        $('html, body').animate({
          scrollTop: ($('input.error').offset().top - 300)
        }, 1000);

        return false;
      }
    });

    $('#edit_address_form, #create_address_form').on('keypress input change', 'input', function (e) {
      $(this).valid();
      
      setTimeout(function () {
        checkErrorMessage();
      }, 100);

      if (e.key === 'Enter') {
        e.preventDefault();
      }
    });

    //Hide default error message if validation error message is present.
    function checkErrorMessage() {
      let elError = $('span.error');
      if (elError) {
        elError.each(function () {
          let defaultMessage = $(this).next();

          if ($(this).text() == '') {
            return false;
          }

          if (defaultMessage.hasClass('form-annotation')) {
            defaultMessage.hide();
          }
        });
      }
    }

    $('#edit_address_form, #create_address_form').validate({
      errorClass: "error",
      errorElement: "span",
      rules: {
        "address[company]": {
          required: true,
          maxlength: 120
        },
        "address[zip]": {
          required: true,
          maxlength: 7,
          number: true
        },
        "address[province]": {
          required: true,
        },
        "address[city]": {
          required: true,
          maxlength: 120
        },
        "address[address1]": {
          required: true,
          maxlength: 120
        },
        "address[address2]": {
          required: false,
          maxlength: 120
        },
        "address[last_name]": {
          required: true,
          maxlength: 120
        },
        "address[first_name]": {
          required: true,
          maxlength: 120
        },
        "last_name_kana": {
          katakana: true,
          required: true,
          maxlength: 120
        },
        "first_name_kana": {
          katakana: true,
          required: true,
          maxlength: 120
        },
        "address[phone]": {
          required: true,
          maxlength: 120,
          hyphen: true,
          number: true
        },
        "acceptable_time_start": {
          required: true,
          checkAcceptableTime: true
        },
        "acceptable_time_end": {
          required: true,
          checkAcceptableTime: true
        },
        "vehicle_weight": { 
          required: true,
        },
        "crane_weight": {
          required: true,
          range: [1, 99]
        },
        "forklift_weight": {
          required: true,
          range: [1, 99]
        }
      },
      messages: {
        "address[province]": {
          equalTo: '選択してください。'
        },
        "customer[acceptable_time_start]": {
          required: '選択してください',
          checkAcceptableTime: '受け入れ開始時間以降の時間で指定してください'
        },
        "customer[acceptable_time_end]": {
          required: '選択してください',
          checkAcceptableTime: '受け入れ開始時間以降の時間で指定してください'
        }
      }
    });

    jQuery.extend(jQuery.validator.messages, {
      equalTo: "同じメールアドレスを入力してください。",
      required: "必須項目です。入力してください。",
      email: "有効なメールアドレスを入力してください。",
      number: "数字で入力してください",
      maxlength: "入力できる文字数を超えています",
      minlength: jQuery.validator.format("{0} 文字以上で入力してください。"),
      range: "1 ～ 99 の値を入力してください。"
    });

    $.validator.addMethod('hyphen', function (value, element) {
      if (value.includes('-') || value.includes('\u3000')) {
        return false;
      }

      return true
    }, 'ハイフンを入れずに入力してください');

    $.validator.addMethod('katakana', function (value, element) {
      let regexKatakana = /^([ァ-ン]|ー)+$/;
      return regexKatakana.test(value);
    }, 'カタカナで入力してください');

    $.validator.addMethod('checkAcceptableTime', function (value, element) {
      let selectStartTimeVal = 0;
      let selectStarEndVal = 0;

      if (selectStartTime.val() !== undefined) {
        selectStartTimeVal = parseInt(selectStartTime.val().split(':')[0]);
      }
    
      if (selectStarEnd.val() !== undefined ) {
        selectStarEndVal = parseInt(selectStarEnd.val().split(':')[0]);
      }
      if (selectStartTimeVal >= selectStarEndVal) {
        return false;
      }

      selectStarEnd.removeClass('error');
      selectStartTime.removeClass('error');

      selectStartTime.next().hide();
      selectStarEnd.next().hide();

      return true;
    }, '受け入れ開始時間以降の時間で指定してください');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  $(document).ready(function () {
    $('#checkout').on('click', function () {
      $('.cart-confirm').addClass('show-popup');
    });

    $('.popup-add-cart__close-icon').on('click', function () {
      $('.popup-add-cart').removeClass('show-popup');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  var elEmail = $('#CustomerEmail');
  var elPassword = $('#CustomerPassword');
  var btnLogin = $('.button-login');
  var regexEmail = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  $('#CustomerEmail, #CustomerPassword').on('input', function () {
    let valEmail = elEmail.val();
    let valPassword = elPassword.val();

    if (regexEmail.test(valEmail) && valPassword) {
      btnLogin.css('background-color', '#02A900').prop('disabled', false);
    } else {
      btnLogin.css('background-color', '#b7b7b7').prop('disabled', true);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
    $(document).ready(function() {
      let inputPassword = $('#CustomerPassword');
      let showPassword = $('#show-password');
      var elEmail = $('#CustomerEmail');
      var elPassword = $('#CustomerPassword');
      var btnLogin = $('.button-login');
      var btnResetPassword = $('#form-forgot-pw .t-button');
      var regexEmail = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

      function setOriginalState() {
        inputPassword.attr('type', 'password');
        showPassword.text('Show');
      }

      showPassword.on('click', () => {
        const isPassword = inputPassword.attr('type') === 'password';

        if (isPassword) {
          inputPassword.attr('type', 'text');
          showPassword.text('Hide');
        } else {
          setOriginalState();
        }
      });

      $('#CustomerPassword, #CustomerEmail').on('input', function() {
        let valEmail = elEmail.val();
        let valPassword =  elPassword.val();

        if (regexEmail.test(valEmail) && valPassword) {
          btnLogin.css('background-color', '#02A900').prop('disabled', false);
        } else {
          btnLogin.css('background-color', '#b7b7b7').prop('disabled', true);
        }
      });

      $('#RecoverEmail').on('input', function() {
        if (regexEmail.test($(this).val())) {
          btnResetPassword.css('background-color', '#02A900').prop('disabled', false);
        } else {
          btnResetPassword.css('background-color', '#b7b7b7').prop('disabled', true);
        }
      });
    });

    function showPage(urlPage, paramId) {
      let elHeaderForgetForm = $('.header-forgot');
      let elHeaderLoginForm = $('.header-login');
      let elForgetForm = $('#form-forgot-pw');
      let elLoginForm = $('.login-page #t-form-login');

      if (paramId) {
        if (urlPage.includes(paramId) || paramId == '#recover') {
          elHeaderForgetForm.show();
          elForgetForm.show();
          elHeaderLoginForm.hide();
          elLoginForm.hide();
        } else {
          elHeaderLoginForm.show();
          elLoginForm.show();
          elHeaderForgetForm.hide();
          elForgetForm.hide();
        }
      }
    }

    var urlPage = window.location.href;
    showPage(urlPage, 'login#recover');

    $(".forgot-password").on('click', function() {
      var paramPageId = $(this).attr('href');
      showPage(urlPage, paramPageId);
    });

    window.onpopstate = function(event) {
      let urlPageLogin = window.location.href;
      let paramId = window.location.hash;

      if (paramId) {
        showPage(urlPageLogin, paramId);
        return true;
      }

      showPage(urlPageLogin, 'login#recover');
    };

    var productUrl = sessionStorage.getItem("productUrl");
    if (productUrl) {
      $("#t-form-login input[name='return_to']").val(productUrl);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  $(document).ready(function () {
    var modal = $('.add-image-popup');
    var thumbnailPopup = $('.product-image--popup');
    var urlImage = $('#image-thumbnail');
    var urlThumbnailPopup = $('.image-thumbnail-popup');
    var productUrl = sessionStorage.getItem('productUrl');

    $('body').on('click', '.main-image', function () {
      thumbnailPopup.addClass('show-popup');
      urlThumbnailPopup.attr('src', urlImage.attr('src'));
    });

    $('body').on('click', '.product-image--popup .popup--close', function () {
      modal.closest('.product-image--popup').removeClass('show-popup');
    });

    $(window).on('click', function (e) {
      if ($(e.target).is('.add-image-popup')) {
        modal.parent().removeClass('show-popup');
      }
    });

    $('body').on('click', '.popup-add-cart__close-icon', function () {
      $('.popup-add-cart').removeClass('show-popup');
    });

    $('.product-image-list--small').on('click', function () {
      let src = $(this).attr('src');
      let index = $(this).index();
      $('.main-image').attr('src', src);
      $('.main-image').attr('data-index', index);
      $('.product-image-list--small').each(function () {
        $(this).removeClass('active');
      });
      $(this).addClass('active');
    });

    $('.product-image--next').on('click', function () {
      let elShowImage = $('.main-image');
      let elShowImagePopup = $('.image-thumbnail-popup');
      let index = elShowImage.attr('data-index');
      let imageSmall = $('.product-image-list--small');

      index = parseInt(index);
      if (imageSmall.length - 1 > index) {
        index += 1;
        elShowImage.attr('src', imageSmall.eq(index).attr('src'));
        elShowImagePopup.attr('src', imageSmall.eq(index).attr('src'));
        elShowImage.attr('data-index', index);
        imageSmall.each(function () {
          $(this).removeClass('active');
          if ($(this).index() == index) {
            $(this).addClass('active');
          }
        });
        return false;
      }

      elShowImage.attr('src', imageSmall.eq(0).attr('src'));
      elShowImagePopup.attr('src', imageSmall.eq(0).attr('src'));
      elShowImage.attr('data-index', '0');
      elShowImagePopup.attr('data-index', '0');
      $(this).removeClass('active');
      imageSmall.eq(0).addClass('active');
    });

    $('.product-image--previous').on('click', function () {
      let elShowImage = $('.main-image');
      let elShowImagePopup = $('.image-thumbnail-popup');
      let index = elShowImage.attr('data-index');
      let imageSmall = $('.product-image-list--small');
      let imageSmallLength = imageSmall.length;

      index = parseInt(index);
      imageSmallLength -= 1;

      if (index > 0) {
        index -= 1;
        elShowImage.attr('src', imageSmall.eq(index).attr('src'));
        elShowImagePopup.attr('src', imageSmall.eq(index).attr('src'));
        elShowImage.attr('data-index', index);
        imageSmall.each(function () {
          $(this).removeClass('active');
          if ($(this).index() == index) {
            $(this).addClass('active');
          }
        });
        return false;
      }

      elShowImage.attr('src', imageSmall.eq(imageSmallLength).attr('src'));
      elShowImagePopup.attr('src', imageSmall.eq(imageSmallLength).attr('src'));
      elShowImage.attr('data-index', imageSmallLength);
      elShowImagePopup.attr('data-index', imageSmallLength);

      imageSmall.each(function () {
        $(this).removeClass('active');
      });

      imageSmall.eq(imageSmallLength).addClass('active');
    });

    $('.popup-add-cart__close-icon').on('click', function () {
      $('.popup-add-cart').removeClass('show-popup');
    });

    if (productUrl) {
      sessionStorage.removeItem('productUrl');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-reset-password"]) return;
  try {
    
  var btnActiveAccount = $('.button-active-account');
  var inputPassword = $('#password');
  var inputConfirmationPassword = $('#password_confirmation');
  var showPassword = $('#show-password');
  var showConfirmPassword = $('#show-password-confirm');
  var formResetPassword = $('#reset-password');
  const passwordRefused = [
    'col12345',
    'col123456',
    'D1lakiss',
    '110110jp',
    'pass@123',
    '1q2w3e4r',
    '1q2w3e4r5t',
    'qwerty123',
    'qwertyu1',
    'qwer1234',
    'qwerty12',
    'qwerty123',
    'q1w2e3r4',
    'q1w2e3r4t5',
    'q1w2e3r4t5y6',
    'qq123456',
    'asdf1234',
    '1g2w3e4r',
    'gwerty123',
    'zag12wsx',
    '1234qwer',
    '12qwaszx',
    '123qweasd',
    '1qazxsw2',
    '1q2w3e4r5t6y',
    '1qaz2wsx3edc',
    '1234abcd',
    '12345abc',
    '123456abc',
    '1234567q',
    '12345678q',
    '123456789q',
    '12345qwert',
    'qwerty12345',
    'abcd1234',
    'asdf1234',
    'asdasd123',
    'a1234567',
    'a123456789',
    'aa12345678',
    '123456789a',
    'password1',
    'password123',
    '123password',
    'passw0rd',
    'target123',
    'princess1',
    'sakura123',
    'iloveyou1',
    'love1234',
    'football1',
    'unknown123',
  ];
  var errorPassword = 1;
  var errorPasswordCnfirmation = 1;

  btnActiveAccount.on('click', function () {
    localStorage.setItem('reset-password-mypage', true);
  });

  function setOriginalState() {
    inputPassword.attr('type', 'password');
    showPassword.text('Show');
  }

  function setOriginalStateConfirm() {
    inputConfirmationPassword.attr('type', 'password');
    showConfirmPassword.text('Show');
  }

  showPassword.on('click', () => {
    const isPassword = inputPassword.attr('type') === 'password';
    const isConfirmationPassword = inputConfirmationPassword.attr('type') === 'password';
    if (isPassword) {
      inputPassword.attr('type', 'text');
      $(this).text('Hide');
    } else {
      setOriginalState();
    }
  });

  showConfirmPassword.on('click', () => {
    const isConfirmationPassword = inputConfirmationPassword.attr('type') === 'password';

    if (isConfirmationPassword) {
      inputConfirmationPassword.attr('type', 'text');
      $(this).text('Hide');

      setOriginalStateConfirm;
    } else {
      setOriginalStateConfirm();
    }
  });

  formResetPassword.validate({
    errorClass: 'error',
    errorPlacement: function (error, element) {
      if (element.attr('name') == 'customer[password]') {
        $('.text-error-password').addClass('error').text(error.text());
        error.appendTo(element.parent('td').next('td'));
        errorPassword = 0;
        if (error.text()) {
          errorPassword = 1;
        }
      } else if (element.attr('name') == 'customer[password_confirmation]') {
        $('.text-error-confirmpw').addClass('error').text(error.text());
        errorPasswordCnfirmation = 0;
        if (error.text()) {
          errorPasswordCnfirmation = 1;
        }
      }
    },
    success: function (element) {
      if (element.attr('name') == 'customer[password]') {
        $('.text-error-password').hide();
        errorPassword = 0;
      } else if (element.attr('name') == 'customer[password_confirmation]') {
        $('.text-error-confirmpw').hide();
        errorPasswordCnfirmation = 0;
      }
      if (errorPassword == 0 && errorPasswordCnfirmation == 0) {
        btnActiveAccount.addClass('active').prop('disabled', false);
      } else {
        btnActiveAccount.removeClass('active').prop('disabled', true);
      }
    },
    rules: {
      'customer[password]': {
        required: true,
        minlength: 8,
        password_strength: true,
        special_characters: true,
      },
      'customer[password_confirmation]': {
        required: true,
        minlength: 8,
        password_strength: true,
        special_characters: true,
        equalTo: '.password-input',
      },
    },
    messages: {
      'customer[password_confirmation]': {
        equalTo: '同じパスワードを入力してください。',
      },
    },
  });

  $.validator.addMethod(
    'password_strength',
    function (value, element) {
      let arrValue = value.split('');

      if (passwordRefused.includes(value) || sameLetters(arrValue) || decrease(arrValue) || ascending(arrValue)) {
        return false;
      }

      return true;
    },
    'このパスワードは安全ではありません'
  );

  $.validator.addMethod(
    'special_characters',
    function (value, element) {
      let check = 0;

      if (checkCharacter(value)) {
        check += 1;
      }

      if (checkNumber(value)) {
        check += 1;
      }

      if (specialCharacter(value)) {
        check += 1;
      }

      if (check >= 2) {
        return true;
      }
      return false;
    },
    '複数の文字種 (英数記号) を組み合わせた8文字以上で入力してください。'
  );

  jQuery.extend(jQuery.validator.messages, {
    required: '必須項目です。入力してください。',
    minlength: '複数の文字種 (英数記号) を組み合わせた8文字以上で入力してください。',
  });

  function checkCharacter(value) {
    let regex = /[a-zA-Z]/;
    return regex.test(value);
  }

  function sameLetters(value) {
    return value.every((char) => char === value[0]);
  }

  function checkNumber(value) {
    let regex = /[0-9]/;
    return regex.test(value);
  }

  function specialCharacter(value) {
    let regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    return regex.test(value);
  }

  function decrease(value) {
    return value.every(function (x, i) {
      return i === 0 || x <= value[i - 1];
    });
  }

  function ascending(value) {
    return value.every(function (x, i) {
      return i === 0 || x >= value[i - 1];
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
